<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<template v-if="$store.state.authentication.account_type != 'ad'">
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>groups</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនអតិថិជនដំណើរការសរុប</p>
							<h3 class="title">{{stat.total_client}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>groups</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនអតិថិជនមិនដំណើរការសរុប</p>
							<h3 class="title">{{stat.total_no_active_client}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>supervised_user_circle</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនអ្នកគ្រប់គ្រងសរុប</p>
							<h3 class="title">{{stat.total_admin}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>manage_accounts</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនអ្នកផ្តល់សេវាសរុប</p>
							<h3 class="title">{{stat.total_provider}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>sports_esports</md-icon>
						</template>
						<template slot="content">
							<p class="category">ចំនួនហ្គេមសរុប</p>
							<h3 class="title">{{stat.total_game}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ក្នុងគណនីអតិថិជនសរុប</p>
							<h3 class="title">{{config.moneylify(stat.total_balance)}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ដាក់ប្រាក់សរុប</p>
							<h3 class="title">{{config.moneylify(stat.total_deposit)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ដកប្រាក់សរុប</p>
							<h3 class="title">{{config.moneylify(stat.total_withdraw)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់អតិថិជនភ្នាល់សរុប</p>
							<h3 class="title">{{config.moneylify(stat.total_bet * -1)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់អតិថិជនឈ្មះសរុប</p>
							<h3 class="title">{{config.moneylify(stat.total_win)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណាយលើការបង្វិល</p>
							<h3 class="title">{{config.moneylify(stat.total_return)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណាយលើអ្នកណែនាំភ្ញៀវ</p>
							<h3 class="title">{{config.moneylify(stat.total_referral)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណាយលើ Promotions</p>
							<h3 class="title">{{config.moneylify(stat.total_promotion)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណេញសរុប</p>
							<h3 class="title">{{config.moneylify((stat.total_bet + stat.total_win) * -1 - stat.total_promotion - stat.total_referral - stat.total_return)}}</h3>
						</template>
					</stats-card>
				</div>
			</template>


			<template>
				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
					<h3>ថ្ងៃនេះ</h3>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ដាក់ប្រាក់សរុប</p>
							<h3 class="title">{{config.moneylify(today.total_deposit)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ដកប្រាក់សរុប</p>
							<h3 class="title">{{config.moneylify(today.total_withdraw)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់អតិថិជនភ្នាល់សរុប</p>
							<h3 class="title">{{config.moneylify(today.total_bet * -1)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់អតិថិជនឈ្មះសរុប</p>
							<h3 class="title">{{config.moneylify(today.total_win)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណាយលើការបង្វិល</p>
							<h3 class="title">{{config.moneylify(today.total_return)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណាយលើអ្នកណែនាំភ្ញៀវ</p>
							<h3 class="title">{{config.moneylify(today.total_referral)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណាយលើ Promotions</p>
							<h3 class="title">{{config.moneylify(today.total_promotion)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណេញសរុប</p>
							<h3 class="title">{{config.moneylify((today.total_bet + today.total_win) * -1 - today.total_promotion - today.total_referral - today.total_return)}}</h3>
						</template>
					</stats-card>
				</div>
			</template>

			<template v-if="$store.state.authentication.account_type != 'ad'">
				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
					<h3>ខែនេះ</h3>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ដាក់ប្រាក់សរុប</p>
							<h3 class="title">{{config.moneylify(month.total_deposit)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ដកប្រាក់សរុប</p>
							<h3 class="title">{{config.moneylify(month.total_withdraw)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់អតិថិជនភ្នាល់សរុប</p>
							<h3 class="title">{{config.moneylify(month.total_bet * -1)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់អតិថិជនឈ្មះសរុប</p>
							<h3 class="title">{{config.moneylify(month.total_win)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណាយលើការបង្វិល</p>
							<h3 class="title">{{config.moneylify(month.total_return)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណាយលើអ្នកណែនាំភ្ញៀវ</p>
							<h3 class="title">{{config.moneylify(month.total_referral)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណាយលើ Promotions</p>
							<h3 class="title">{{config.moneylify(month.total_promotion)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">ទឹកប្រាក់ចំណេញសរុប</p>
							<h3 class="title">{{config.moneylify((month.total_bet + month.total_win) * -1 - month.total_promotion - month.total_referral - month.total_return)}}</h3>
						</template>
					</stats-card>
				</div>

				<md-card>
					<md-card-header data-background-color="orange">
						<h4>ស្វែងរកទិន្នន័យ</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-field>
									<label>ថ្ងៃចាប់ផ្តើម</label>
									<md-input type="text" v-model="start_date" style="display:none" />
									<datetime type="datetime" v-model="start_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">

								<md-field>
									<label>ថ្ងៃបញ្ចប់</label>
									<md-input type="text" v-model="end_date" style="display:none" />
									<datetime type="datetime" v-model="end_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-button class="md-raised md-primary" style="width:100%" @click="getRange()">បង្ហាញ
								</md-button>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ដាក់ប្រាក់សរុប</p>
										<h3 class="title">{{config.moneylify(range.total_deposit)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ដកប្រាក់សរុប</p>
										<h3 class="title">{{config.moneylify(range.total_withdraw)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ទឹកប្រាក់អតិថិជនភ្នាល់សរុប</p>
										<h3 class="title">{{config.moneylify(range.total_bet * -1)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ទឹកប្រាក់អតិថិជនឈ្មះសរុប</p>
										<h3 class="title">{{config.moneylify(range.total_win)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ទឹកប្រាក់ចំណាយលើការបង្វិល</p>
										<h3 class="title">{{config.moneylify(range.total_return)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ទឹកប្រាក់ចំណាយលើអ្នកណែនាំភ្ញៀវ</p>
										<h3 class="title">{{config.moneylify(range.total_referral)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ទឹកប្រាក់ចំណាយលើ Promotions</p>
										<h3 class="title">{{config.moneylify(range.total_promotion)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">ទឹកប្រាក់ចំណេញសរុប</p>
										<h3 class="title">{{config.moneylify((range.total_bet + range.total_win) * -1 - range.total_promotion - range.total_referral - range.total_return)}}</h3>
									</template>
								</stats-card>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</template>

		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'
	import { Datetime } from 'vue-datetime';

	export default {
		components: {
			StatsCard,
			Datetime
		},
		mounted() {

		},
		created() {
			this.$http.get(this.config.api + "/admin/get/stat").then(data => {
				this.stat = data.body.data
				this.loaded = true;
			});
			this.getToday();
			this.getMonth();
		},
		methods: {
			getToday() {
				this.$http.get(this.config.api + "/admin/get/stat/day").then(data => {
					this.today = data.body.data
				});
			},
			getMonth() {
				this.$http.get(this.config.api + "/admin/get/stat/month").then(data => {
					this.month = data.body.data
				});
			},
			getRange() {
				let start_date = (new Date(this.start_date)).getTime();
				let end_date = (new Date(this.end_date)).getTime();

				this.$http.get(this.config.api + "/admin/get/stat/range/" + start_date + "/" + end_date).then(data => {
					this.range = data.body.data
					// this.loaded = true;
				});
			}
		},
		computed: {
		},
		data() {
			return {
				loaded: true,
				stat: {
					total_admin: 0,
					total_game: 0,
					total_provider: 0,
					total_client: 0,
					total_no_active_client: 0,
					total_balance: 0,
					total_deposit: 0,
					total_withdraw: 0,
					total_bet: 0,
					total_win: 0,
					total_return: 0,
					total_referral: 0,
					total_promotion: 0
				},
				today: {
					total_deposit: 0,
					total_withdraw: 0,
					total_bet: 0,
					total_win: 0,
					total_return: 0,
					total_referral: 0,
					total_promotion: 0
				},
				month: {
					total_deposit: 0,
					total_withdraw: 0,
					total_bet: 0,
					total_win: 0,
					total_return: 0,
					total_referral: 0,
					total_promotion: 0
				},
				start_date: "",
				end_date: "",
				range: {
					total_deposit: 0,
					total_withdraw: 0,
					total_bet: 0,
					total_win: 0,
					total_return: 0,
					total_referral: 0,
					total_promotion: 0
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue